import { render, staticRenderFns } from "./UnitManagement.vue?vue&type=template&id=2d522724&scoped=true&"
import script from "./UnitManagement.vue?vue&type=script&lang=js&"
export * from "./UnitManagement.vue?vue&type=script&lang=js&"
import style0 from "./UnitManagement.vue?vue&type=style&index=0&id=2d522724&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d522724",
  null
  
)

export default component.exports